module.exports = __webpack_public_path__ + "static/media/card-graduacao.642575be.png";